<template>
  <div :class="labelClass">
    {{ timeLabel }}
  </div>
</template>

<script>
import { customDateFormatWithTimezone } from "../mixins";

export default {
  props: {
    labelClass: {
      type: String,
      default: "flex timezone-time text-xs text-gray-500 whitespace-nowrap"
    },
    format: {
      type: String,
      default: "ddd, MM/DD/YYYY - h:mm A"
    }
  },
  data() {
    return {
      abbreviation: window.currentTenant.timezone_abbreviation,
      timeLabel: "",
      interval: null
    };
  },
  created() {
    this.timeLabel = this.getTimeLabel();
    this.startClock();
  },
  methods: {
    startClock() {
      if (this.interval) {
        clearInterval(this.interval);
      }
      this.interval = setInterval(() => {
        this.timeLabel = this.getTimeLabel();
      }, 1000);
    },
    getTimeLabel() {
      return `${customDateFormatWithTimezone(new Date(), this.format)} ${
        this.abbreviation
      }`;
    }
  }
};
</script>

<style lang="scss" scoped>
.timezone-time {
  font-weight: normal !important;
}
</style>
